import { render, staticRenderFns } from "./commentImages.vue?vue&type=template&id=3764c835"
import script from "./commentImages.vue?vue&type=script&lang=js"
export * from "./commentImages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports